import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AddAprRateComponent } from 'src/app/core/dialogs/add-apr-rate/add-apr-rate.component';
import { DeleteAPRCostComponent } from 'src/app/core/dialogs/delete-apr-rate/delete-aprcost.component';
import { BtnCellRenderer } from 'src/app/core/grid/btn-cell-render.component';
import { AprRatesService } from 'src/app/service/apr-rates.service';
import { CopyAprRatesComponent } from 'src/app/core/dialogs/copy-apr-rates/copy-apr-rates.component';
import { AddFiscalYearComponent } from 'src/app/core/dialogs/add-fiscal-year/add-fiscal-year.component';
import { FiscalYearService } from 'src/app/service/fiscal-year.service';
import { UsersService } from 'src/app/service/users.service';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { RefreshGridComponent } from 'src/app/core/refresh-grid/refresh-grid.component';
import { Router } from '@angular/router';

export interface DialogData {
	performAction: string;
	page;

	placeholder_rateId;
	placeholder_fiscalYear: string;
	placeholder_domicile: string;
	placeholder_otr;
	placeholder_handling;
}

export interface CopyFYDialogData {
	performAction: string;
	page;

	placeholder_srcFY;
	placeholder_targetFY: string;
	placeholder_user;
}

export interface deleteAprCostData {
  id: Number;
  domicile: string;
  page;
}

@Component({
    selector: 'app-apr-rates',
    templateUrl: './apr-rates.component.html',
    styleUrls: ['./apr-rates.component.scss'],
    standalone: false // NOSONAR
})
export class AprRatesComponent implements OnInit {
	gridApi: any;
	gridColumnApi: any
	currentPageNo: any;
	currentPageBoolean: boolean = false;
	currentPageForTotalPage: any;
	isLastPageFound: any;
	paginationPageSize: number = 30;
	setPagination = 'true';

	columnDefs;
	icons;
	defaultColDef;

	fiscalYears: any = [];
	fiscalYearChosen = '';
	rowData: any[];
	tempData: any[];
	selectedRows: any = [];
	temp;
	enableGrid: boolean = false;
	fiscalYear: any;
	copyYearClicked: boolean = false;
	pipe: DatePipe;

	usertemp: string;
	userInfo: any;
	strUserName;
	
	frameworkComponents;
	context: any;
	successMessage = '';
	errorMessage = '';

	@ViewChild('agGrid', { static: true }) agGrid
	dynamicHeight: number;
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 30;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
		{value: 30 , selected : true},
		{value: 50 , selected : false},
	]
	originalPage: any;

	constructor(private readonly aprRatesService: AprRatesService, private readonly ngxUiLoaderService: NgxUiLoaderService, 
		public dialog: MatDialog, private readonly  fiscalYearService: FiscalYearService, private readonly usersService: UsersService,
		private readonly router: Router) {
		this.dynamicHeight = 0.665 * (window.innerHeight);

		// booting up the ag grid
		this.context = {
			componentParent: this
		};

		this.columnDefs = [
			{
				headerName: '', width: 40, maxWidth: 40, minWidth: 40, autoHeight: true, floatingFilterComponent: RefreshGridComponent,
				suppressHeaderMenuButton: true, filter: 'agTextColumnFilter', sortable: false, suppressHeaderFilterButton: true,
				floatingFilterComponentParams: { suppressFilterButton: true }
			},
			{
				headerName: "DOMICILE", headerClass: "domicile", field: "domicile", cellClass: "cell_domicile", width: 120,
				autoHeight: true, sortable: true, unSortIcon: true, filter: 'agTextColumnFilter'
			},
			{
				headerName: "OTR", headerClass: "otr", field: "overTheRoad", cellClass: "cell_otr", width: 120, autoHeight: true,
				// floatingFilter: true, 
				floatingFilterComponentParams: { suppressFilterButton: true }, filter: 'agTextColumnFilter', sortable: true, unSortIcon: true
			},
			{
				headerName: "HANDLING", headerClass: "handling", field: "handlingCharge", cellClass: "cell_handling", width: 120, autoHeight: true,
				// floatingFilter: true, 
				floatingFilterComponentParams: { suppressFilterButton: true }, filter: 'agTextColumnFilter', sortable: true, unSortIcon: true
			},
			{
				headerName: "CREATED BY", headerClass: "createdBy", field: "createdBy", cellClass: "cell_createdBy",
				width: 120, autoHeight: true, sortable: true, unSortIcon: true, filter: 'agTextColumnFilter'
			},
			{
				headerName: "CREATED ON", field: "createdDate", floatingFilterComponentParams: { suppressFilterButton: true },
				width: 150, autoHeight: true, sortable: true, unSortIcon: true
			},
			{
				headerName: "ACTIONS", field: "aprrates_action", width: 120,
				headerClass: "editdelete", cellRenderer: BtnCellRenderer,
				cellRendererParams: {
					clicked: function (_field: any, _act: any) {
						 console.info('some')
					}
				}
			}];

		this.frameworkComponents = {
			btnCellRenderer: BtnCellRenderer
		};

		this.icons = {
			sortUnSort: '<img src="./assets/images/unsort.svg">',
		  };

		this.defaultColDef = {
			minWidth: 100,
			floatingFilter: true,
			wrapText: true
		};
	}

	ngOnInit(): void { // NOSONAR 
		if(!(window.location.href.toString().includes('aprrates'))) {
			this.router.navigate(['/aprrates']);
		}
		this.pipe = new DatePipe('en-US');
		this.loadFYData();
	}

	loadFYData() {
		this.ngxUiLoaderService.start("loader-01");
		//get fiscal year list - api
		this.fiscalYears = [];

		this.fiscalYearService.getFiscalYearList().subscribe(result => {
			console.info("calling getFiscalYearList");
			if (result?.length > 0) {
				//storing fiscal year data in local
				localStorage.setItem('fiscal-year-data', JSON.stringify(result));
				this.fiscalYears = result;
			}
			else {
				setTimeout(() => {
					this.successMessage = '';
					this.errorMessage = '';
				}, 6500);
			}
			this.ngxUiLoaderService.stop("loader-01");
		});
	}

	getUserInfo() {
		this.ngxUiLoaderService.start("loader-01");
		//get user info - api
		const guid = localStorage.getItem('toyotaGUID');

		this.usersService.getUserInfo(guid).subscribe(result => {
			console.info("calling getUserInfo");
			if (result?.length > 0) {
				//storing user-info data in local
				localStorage.setItem('user-info', JSON.stringify(result));
			}
			else {
				setTimeout(() => {
					this.successMessage = '';
					this.errorMessage = '';
				}, 6500);
			}
			this.ngxUiLoaderService.stop("loader-01");
		});
	}

	getUserName(){
		this.ngxUiLoaderService.start("loader-01");

		//fetch from local-storage
		// this.usertemp = localStorage.getItem('user-info'); // Commented to the same info from 
		this.usertemp = sessionStorage.getItem('FGA');
		this.userInfo = JSON.parse(this.usertemp);
		console.info("usertemp" ,this.usertemp);
		this.strUserName = this.userInfo?.user?.userPrincipalName;
  
		this.ngxUiLoaderService.stop("loader-01");
	}

	display() {
		if (this.fiscalYearChosen) {
			this.enableGrid = true;
			this.rowData = [];
			this.tempData = [];

			this.ngxUiLoaderService.start("loader-01");

			console.info("the selected fiscal year", this.fiscalYearChosen);
			this.aprRatesService.getAPRCostsForFiscalYear(this.fiscalYearChosen).subscribe(aprCostData => {
				aprCostData?.forEach(e => {
					const obj = {
						"rateId": undefined, "domicile": undefined, "overTheRoad": undefined, "handlingCharge": undefined, "createdDate": undefined, "createdBy": undefined
					};

					obj.rateId = e.rateId;
					obj.domicile = e.domicile;
					obj.overTheRoad = e.overTheRoad;
					obj.handlingCharge = e.handlingCharge;
					obj.createdBy = e.createdBy;
					obj.createdDate = this.convertDateFormat(e.createdDate);

					this.tempData.push(obj);
					console.info("APR Cost data set to the object")
				});
				this.rowData = this.tempData;
				if (this.rowData.length) {
					this.totalRecords = this.rowData.length;
					this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
					this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
					this.sRecord = 1
					this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
					if (this.cPage > this.tPage) {
						this.cPage = 1;
					}
				}
				this.ngxUiLoaderService.stop("loader-01");
			});
		}
		else {
			this.enableGrid = false;
		}
	}

	sizeToFit() { this.gridApi.sizeColumnsToFit(); }

	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

	onPageSizeChanged(event: any) { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails(); }

	getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event:any) {
		this.cPage = 1;
		this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}

	onGridReady(params: any) {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		this.gridApi.sizeColumnsToFit();
	}

	deleteAprCostRow(val) {
		let id;
		let domicile;

		this.rowData.filter(x => x.rateId == val).forEach(e => {  // NOSONAR
			this.selectedRows.push(e);
			id = e.rateId;
			domicile = e.domicile;
		});

		console.info("rateId", id);
		const dialogRef = this.dialog.open(DeleteAPRCostComponent, {
			disableClose: true,
			width: '510px',
			data: { id: id, domicile: domicile, page: 'apr rate' }
		});
		
		dialogRef.afterClosed().subscribe(result => {
			if(result != undefined) { // NOSONAR
				console.info("result:", result);
				console.info("data to be deleted:", id);

				const deletejson = {
					"rateId": result.data
				}
				this.deleteAPRCostRecord(deletejson);
				console.info("json", deletejson);
			}
		});
	}

	deleteAPRCostRecord(dataArr) {
		this.ngxUiLoaderService.start("loader-01");

		this.aprRatesService.deleteAprCost(dataArr).subscribe(_result => {
			this.successMessage = 'APR Cost Record Deleted Successfully!';
			setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			}, 6500);

			this.enableGrid = false;
			//fetch latest data after deleting
			this.display();
		});
	}

	editAprCostRow(val) {
		let fiscalYear
		let domicile;
		let otr;
		let id;
		let handling;

		this.rowData.filter(x => x.rateId == val).forEach(e => {  // NOSONAR
		  fiscalYear = e.fiscalYear;
		  otr = e.overTheRoad;
		  id = e.rateId;
		  domicile = e.domicile;
		  handling = e.handlingCharge;
		});
	
		console.info("rateId", id);	console.info("fiscalYear", fiscalYear); console.info("otr", otr);	console.info("handling", handling);
		console.info("fiscalYear selected", this.fiscalYearChosen);    console.info("Domicile in parent edit", domicile);

		const dialogRef = this.dialog.open(AddAprRateComponent, {
		  disableClose: true,
		  width: '410px',
		  data: { performAction: 'EditCell', placeholder_rateId: id, placeholder_fiscalYear: this.fiscalYearChosen, placeholder_otr: otr, 
		  placeholder_handling: handling, page: 'APR Cost', placeholder_domicile: domicile }
		});

		this.getUserName();		// To get the updatedBy user
	
		dialogRef.afterClosed().subscribe(result => {
		  
	
		  if (result != undefined && result.event == 'EditCell') {  // NOSONAR
			//API Integration
			const dataArr = {
	   		    "rateId" : result.data0,
			  	"fiscalYear": result.data1,
			  	"domicile" : result.data2,
			  	"overTheRoad" : result.data3,
			  	"handlingCharge" : result.data4,
			    "updatedBy": this.strUserName
			}
	
			this.ngxUiLoaderService.start("loader-01");
			this.aprRatesService.editAPRCost(dataArr).subscribe(result => {
				console.info(result,"result")
				if(result){
					this.successMessage = 'APR Rate updated successfully!';
				}else {
					this.errorMessage = "Something went wrong. Please Contact system administrator"
				}
			  
			  setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			  }, 6500);
	
			  //fetch latest row data after editing
			  this.display();
			  // }
			});
		  }
		});
	}

	refreshData() {
		this.display();
	}

	addAPRCost(): void {
		console.info("open dialog");
		const dialogRef = this.dialog.open(AddAprRateComponent, {
		  disableClose: true,
		  width: '410px',
		  data: { performAction: 'AddCell', placeholder: '', placeholder_fiscalYear: this.fiscalYearChosen }
		});

		this.getUserName();		// To get the createdBy user name
	
		dialogRef.afterClosed().subscribe(result => {
		  

		  if (result != undefined && result.event == 'AddCell') {  // NOSONAR
			//API Integration
			const dataArr = {
			  	"fiscalYear": result.data1,
			  	"domicile" : result.data2,
			  	"overTheRoad" : result.data3,
			  	"handlingCharge" : result.data4,
				"createdBy" : this.strUserName
			}

			console.info("data arr", dataArr);
	
			this.ngxUiLoaderService.start("loader-01");
			this.aprRatesService.addAprCost(dataArr).subscribe(result => {
	
			  console.info("result", result);
	
			  if (result) {
				this.display();
	
				this.successMessage = 'APR Rate added successfully!';
				setTimeout(() => {
				  this.successMessage = '';
				  this.errorMessage = '';
				}, 5000);
			  }
			  else {
				this.display();
	
				this.errorMessage = 'APR Rate already exists!';
				setTimeout(() => {
				  this.successMessage = '';
				  this.errorMessage = '';
				}, 5000);
			  }
			});
		  }
		});
	}

	addFiscalYear(): void {
		console.info("open dialog");
		const dialogRef = this.dialog.open(AddFiscalYearComponent, {
		  disableClose: true,
		  width: '410px',
		  data: { performAction: 'AddCell', placeholder: '' }
		});
	
		dialogRef.afterClosed().subscribe(result => {
		  
	
		  if (result != undefined && result.event == 'AddCell') {  // NOSONAR
			//API Integration
			const dataArr = {
			  	"fiscalYear": result.data1,
				"createdBy" : result.data2
			}

			console.info("data arr", dataArr);
	
			this.ngxUiLoaderService.start("loader-01");
			this.fiscalYearService.addFiscalYear(dataArr).subscribe(result => {
	
			  console.info("result", result);
	
			  if (!result) {
				this.display();
	
				this.errorMessage = 'Fiscal Year already exists!';
				setTimeout(() => {
				  this.successMessage = '';
				  this.errorMessage = '';
				}, 5000);
			  }
			  else if (result) {
				this.successMessage = 'Fiscal Year added successfully!';
				setTimeout(() => {
				  this.successMessage = '';
				  this.errorMessage = '';
				}, 5000);
			  }
			  this.ngxUiLoaderService.stop("loader-01");
			});
		  }
		});
	}

	copyFiscalYear(val): void {
		this.copyYearClicked = true;
		console.info("open dialog to copy apr data from a fiscal year to another");
		
		let srcFY;
		let targetFY;
		console.info(val)
	console.info(this.rowData)
		this.rowData.filter(x => x.rateId == val).forEach(e => {  // NOSONAR
   		  srcFY = e.fiscalYear;
		  targetFY = e.fiscalYear;
		});
	
		console.info("src Fiscal Year", srcFY);	console.info("target Fiscal Year", targetFY);

		const dialogRef = this.dialog.open(CopyAprRatesComponent, {
		  disableClose: true,
		  width: '410px',
		  data: { performAction: 'CopyCell', placeholder_srcFY: srcFY,  
		  placeholder_targetFY: targetFY, page: 'APR Cost', placeholder_user: this.strUserName }
		});
	
		dialogRef.afterClosed().subscribe(result => {
		  
	
		  if (result != undefined && result.event == 'CopyCell') { // NOSONAR
			//API Integration
			const dataArr = {
			  	"fiscalYear": result.data1,
			  	"newFiscalYear" : result.data2,
			    "userId": result.data3
			}
	
			this.ngxUiLoaderService.start("loader-01");
			this.aprRatesService.copyAprCost(dataArr).subscribe(_result => {
			this.successMessage = 'APR Rate data from selected fiscal year copied successfully!';
			  setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			  }, 6500);
	
			  //Reload the fiscal year dropdown after copying to show the new fiscal year
			  this.loadFYData();
			  
			// Attempt to load the data for the new copied year for quick editing
			  // this.fiscalYearChosen = dataArr.newFiscalYear;
			  // this.display();
			}, error => {
				this.ngxUiLoaderService.stop("loader-01")
				if(error == "DUPLICATE_FISCAL_YEAR - Target Fiscal year entered already exists"){  // NOSONAR
					this.errorMessage = "Duplicate Fiscal Year - Target Fiscal year entered already exists"
				}else {
					this.errorMessage = "Something went wrong. Please Contact system administrator"
				}
				setTimeout(() => {
					this.successMessage = '';
					this.errorMessage = '';
				  }, 6500);
				// this.ngxUi
			  });
		  }
		});
	}

	convertDateFormat(date) {
		return this.pipe.transform(date, 'MM/dd/yyyy HH:mm', 'EST');
	}
}
